'use client';

import * as React from 'react';
import { useRouter } from '@/i18n/routing';

import { getServerEnv } from '@/lib/constants/environment';

const { NEXT_PUBLIC_CONTENT_REFRESH_ENABLED, CONTENT_REFRESH_WS } = getServerEnv();

const Noop = ({ children }) => children;

declare global {
  interface Window {
    WS_CONTENT: WebSocket;
  }
}

const getWsConnection = () => {
  if (window.WS_CONTENT) {
    return window.WS_CONTENT;
  }

  window.WS_CONTENT = new WebSocket(CONTENT_REFRESH_WS);

  window.WS_CONTENT.onopen = () => {
    console.info('[Content Refresh] Sucessfully initialized WS connection.');
  };

  window.WS_CONTENT.onerror = (error) => {
    console.info('[Content Refresh] WS connection error:', error);
  };

  return window.WS_CONTENT;
};

const WithContentRefresh = ({ children }) => {
  const router = useRouter();

  React.useEffect(() => {
    const ws = getWsConnection();

    ws.onmessage = (event) => {
      if (event.data === 'refresh') {
        console.info('[Content Refresh] Received refresh event');
        router.refresh();
      }
    };
  }, [router]);

  return children;
};

export const ContentRefresh = NEXT_PUBLIC_CONTENT_REFRESH_ENABLED ? WithContentRefresh : Noop;
